<template>
  <div>
    <div v-if="error_message" class="field_with_errors"><p class="error">{{error_message}}</p></div>
    <div class="datetime_wrap">
      <div class="select_wrap">
        <select name="end_date(1i)" id="form_end_date_1i" v-model="year">
          <option value=""></option>
          <option v-for="val in end_to_end" :value="val"><!-- ★ valueにinfoというオブジェクトを設定 -->
            {{ val }}
          </option>
        </select>
      </div>

      <div class="select_wrap">
        <select name="end_date(2i)" id="form_end_date_2i" v-model="month">
          <option value=""></option>
          <option value="1">01</option>
          <option value="2">02</option>
          <option value="3">03</option>
          <option value="4">04</option>
          <option value="5">05</option>
          <option value="6">06</option>
          <option value="7">07</option>
          <option value="8">08</option>
          <option value="9">09</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option>
        </select>

      </div>

      <div class="select_wrap">
        <select name="end_date(3i)" id="form_end_date_3i" v-model="day">
          <option value=""></option>
          <option v-for="(key,val) in end_to_end_day" :value="key"><!-- ★ valueにinfoというオブジェクトを設定 -->
            {{ key }}
          </option>
        </select>

      </div>

    </div>

  </div>

</template>
<script>
import CommonModule from "../../module/common";

export default {
  init_prop_info_list: {},
  props: {
    prop_start_year: {type: Number, default: ""},
    prop_end_year: {type: Number, default: ""},
    prop_key: {type: String, default: ""},
    prop_default_year: {type: Number, default: ""},
    prop_default_month: {type: Number, default: ""},
    prop_default_day: {type: Number, default: ""},
  },
  data() {
    return {
      //初期値
      year: this.prop_default_year,
      month: this.prop_default_month,
      day: this.prop_default_day,
      end_to_end: [],
      end_to_end_day: [],
      error_message: "",
    }
  },
  watch: {
    year: function () {
      this.set_date();
      this.validate();
      index_simulator.simulate();
      this.$parent.check_submit();

    },
    month: function () {
      this.set_date();
      this.validate();
      index_simulator.simulate();
      this.$parent.check_submit();

    },
    day: function () {
      this.validate();
      index_simulator.simulate();
      this.$parent.check_submit();
    },

  },
  methods: {
    set_date() {
      if (this.year && this.month) {
        this.end_to_end_day = CommonModule.formSetDay(this.year, this.month);

      }

    },
    /*
    * 入力のチェック
    * */
    validate(){
      const simulator_end_date_year = parseInt(this.year);
      const simulator_end_date_month = parseInt(this.month);
      const simulator_end_date_day = parseInt(this.day);

      //エラーメッセージの初期化
      this.error_message = '';
      if(!simulator_end_date_year){
        return false;
      }
      if (!isDate(simulator_end_date_year + '/' + simulator_end_date_month + '/' + simulator_end_date_day)) {
        if( this.year != "" && this.month != "" && this.day != "" ){
          this.error_message = '保険終期日が存在しない日付です。';
        }
        return false;
      }

      /*
      * 下記はグローバル変数
      * selectable_restrect_end_date_end
      * selectable_restrect_end_date_start
      * selectable_restrect_end_date_end_message
      * selectable_restrect_end_date_end
      * selectable_restrect_end_date_end_message
      * */

      //終期日が違う
      if (selectable_start_date && selectable_start_date > getDate(simulator_end_date_year + '/' + simulator_end_date_month + '/' + simulator_end_date_day + ' 23:59:59')) {

        if (contractable_period_start_date_message) {
          this.error_message = contractable_period_start_date_message;
        } else{
          this.error_message = '保険終期日を' + getStrDate(selectable_start_date) + '以降でご設定ください。';
        }

        return false;
      }

      //終期日が違う 終了日計算
      if (selectable_end_date && selectable_end_date < getDate(simulator_end_date_year + '/' + simulator_end_date_month + '/' + simulator_end_date_day + ' 00:00:00')) {


        if (contractable_period_end_date_message) {
          this.error_message = contractable_period_end_date_message;
        } else{
          this.error_message = '保険終期日を' + getStrDate(selectable_end_date) + '以前でご設定ください。';
        }

        return false;
      }

      //当日以降のみ許可
      if (new Date() > getDate(simulator_end_date_year + '/' + simulator_end_date_month + '/' + simulator_end_date_day + ' 23:59:59')) {
        this.error_message = '過去の保険終期日はご選択できません。';
        return false;
      }

      if (selectable_restrect_end_date_start !== '' && CommonModule.check_date_gt(selectable_restrect_end_date_start, getDate(simulator_end_date_year + '/' + simulator_end_date_month + '/' + simulator_end_date_day + ' 23:59:59'))) {
        if (selectable_restrect_end_date_start_message) {
          this.error_message = selectable_restrect_end_date_start_message;
        } else {
          this.error_message = '保険終期日を' + selectable_restrect_end_date_start + '日以降に設定してください。';
        }

        return false;
      }

      if (selectable_restrect_end_date_end !== '' && CommonModule.check_date_lt(selectable_restrect_end_date_end, getDate(simulator_end_date_year + '/' + simulator_end_date_month + '/' + simulator_end_date_day + ' 00:00:00'))) {
        if (selectable_restrect_end_date_end_message) {
          this.error_message = selectable_restrect_end_date_end_message;
        } else {
          this.error_message = '保険終期日を' + selectable_restrect_end_date_end + '日以内に設定してください。';
        }

        return false;
      }

      //終期日が選択した始期日より前の日付は不可

      let select_year = $('#form_start_date_1i').val();
      let select_month = $('#form_start_date_2i').val();
      let select_day = $('#form_start_date_3i').val();
      if (this.year && this.month && this.day && select_year && select_month && select_day) {
        const start_date = new Date(select_year, select_month - 1, select_day);
        const end_date = new Date(this.year, this.month - 1, this.day);

        if (end_date < start_date) {
          this.error_message = '保険終期日は保険始期日以降の日付を選択してください。';
          return false;
        }
      }


      return true; //バリデーションOK
    }

  },
  mounted() {
    this.set_date();

    var v = this;
    setTimeout(function(){

      let select_year = $('#form_end_date_1i').val();
      if (select_year){
        v.year = select_year;
      }

      let select_month = $('#form_end_date_2i').val();
      if (select_month){
        v.month = select_month;
      }


      let select_day = $('#form_end_date_3i').val();
      if (select_day){
        v.day = select_day;
      }
    },100);

  },
  created() {
    this.end_to_end = CommonModule.range(this.prop_start_year, this.prop_end_year);
    this.set_date();

  }
}
</script>
